import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../../tools/store";
import { AuthenticationSliceInterface } from "./types";

const initialState: AuthenticationSliceInterface = {
  session: null,
};
export const AuthenticationReducerName = "authentication";

export const AuthenticationSlice = createSlice({
  name: AuthenticationReducerName,
  initialState,
  reducers: {
    setSession: (state, action) => {
      state.session = action.payload;
    },
    signOut: (state) => {
      state.session = null;
    },
  },
});

export const { setSession, signOut } = AuthenticationSlice.actions;
export const getSession = (state: RootState) => state.authentication.session;

export default AuthenticationSlice.reducer;
